import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { APP_NAME } from 'constants/views';

import { FormBox, FormFlex, FormGroupAdapter } from 'components/shared/form';

import { validateRequired } from 'utils';

import { AccurateInformation, Disclaimer, CreditAndBackgroundRelease, InvestmentPurpose, Waiver, AffiliateBusiness, ElectronicSignatures } from './shared';

const propTypes = {
  disabled: PropTypes.bool,
  signatureVersion: PropTypes.string,
  acknowledgmentCheckboxesVersion: PropTypes.string,
};

const defaultProps = {
  disabled: true,
  signatureVersion: 'v1',
  acknowledgmentCheckboxesVersion: 'v2',
};

function Fields({ disabled, signatureVersion, acknowledgmentCheckboxesVersion }) {
  if (APP_NAME === 'LendingOne') {
    return (
      <Fragment>
        <CreditAndBackgroundRelease disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />
        <InvestmentPurpose disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />
        <AccurateInformation disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />
        <Disclaimer disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />
        <Waiver disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />
        <AffiliateBusiness disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />
        <ElectronicSignatures disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />

        <FormFlex>
          <FormBox width={1}>
            <Field
              name="application.borrower.signedByName"
              label="Full Legal Name"
              required
              cursive
              disabled={disabled}
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
        </FormFlex>

        <FormFlex>
          <FormBox width={1}>
            <Field
              name="application.borrower.signedDate"
              label="Date"
              type="date"
              required
              disabled
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
        </FormFlex>
      </Fragment>
    );
  }
  return (
    <Fragment>
      <AccurateInformation disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />
      <InvestmentPurpose disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />
      <Disclaimer disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />

      <FormFlex>
        <FormBox width={1}>
          <Field
            name="application.borrower.signedByName"
            label="Full Legal Name"
            required
            cursive
            disabled={disabled}
            validate={validateRequired()}
            component={FormGroupAdapter}
          />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <Field
            name="application.borrower.signedDate"
            label="Date"
            type="date"
            required
            disabled={disabled}
            validate={validateRequired()}
            component={FormGroupAdapter}
          />
        </FormBox>
      </FormFlex>
    </Fragment>
  );
}

Fields.propTypes = propTypes;
Fields.defaultProps = defaultProps;

export default Fields;
